import { useInfiniteQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import {
  getNotifyContacts,
  GetNotifyContactsParamsType,
  GetNotifySubscriberContactMethodsParamsType,
} from "../../../queries/notify";
import { useMemo } from "react";

export function useInfiniteNotifyContacts(params: GetNotifyContactsParamsType) {
  const networkHeaders = useNetworkHeaders();
  const {
    data,
    isLoading: isNotifyContactsLoading,
    isFetching: isNotifyContactsFetching,
    fetchMore: fetchMoreNotifyContacts,
    canFetchMore: canFetchMoreNotifyContacts,
  } = useInfiniteQuery(buildNotifyContactsQueryKey(params), getNotifyContacts(networkHeaders), {
    queryFnParamsFilter(args) {
      return [args[1]];
    },
    getFetchMore: (lastPage) => lastPage.data.at(-1)?.cursor?.join(","),
    keepPreviousData: true,
    enabled: params.status == "Enrolled",
  });

  const notifyContacts = useMemo(() => data?.flatMap(({ data }) => data) ?? [], [data]);
  const lastPage = data?.at(-1);

  return {
    notifyContactsTypeTotalCount: lastPage?.aggregations.totalTypeCount ?? 0,
    notifyContactMethodsTypeCount: lastPage?.aggregations.typeCounts ?? null,
    notifyContactsTotal: lastPage?.total ?? 0,
    notifyContacts,
    isNotifyContactsLoading,
    isNotifyContactsFetching,
    fetchMoreNotifyContacts,
    canFetchMoreNotifyContacts,
  };
}

export function buildNotifyContactsQueryKey(params?: GetNotifySubscriberContactMethodsParamsType) {
  if (!params) {
    return "useInfiniteNotifyContacts";
  }
  return ["useInfiniteNotifyContacts", params];
}
